import React from 'react';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';
import PropTypes from 'prop-types';

import iconSet from '../../../../../shared/images/teambuildr-selection.json';

const SearchAndIcon = styled('div')`
  align-items: center;
  background: white;
  border: ${(props) => (props.isFocused ? '1px solid   #5F8BDC' : '1px solid #EEEEEE')};
  border-radius: 50px;
  display: flex;
  max-width: ${(props) => (props.isFocused ? '250px' : '40px')};
  overflow: hidden;
  transition: max-width 0.5s ease;
`;

const SearchContainer = styled('input')`
  background: none;
  border: none;
  color: #444444;
  display: flex;
  height: 40px;
  padding-left: 5px;
`;

const SearchIconContainer = styled('div')`
  align-items: center;
  display: flex;
  justify-content: center;
  padding-left: 10px;
  padding-right: 5px;
`;

const TemplateSearchBar = ({
  handleClick,
  iconContainerId,
  iconId,
  id,
  isFocused,
  searchId,
  searchRef,
  searchTerm,
  setSearchTerm,
}) => (
  <SearchAndIcon
    id={id}
    onClick={handleClick}
    isFocused={isFocused}
  >
    <SearchIconContainer id={iconContainerId}>
      <IcomoonReact
        iconSet={iconSet}
        size={20}
        icon='magnifying-glass-alt'
        id={iconId}
      />
    </SearchIconContainer>
    <SearchContainer
      ref={searchRef}
      placeholder='Search'
      id={searchId}
      value={searchTerm}
      onFocus={handleClick}
      onChange={(inputValue) => {
        setSearchTerm(inputValue.target.value);
      }}
    />
  </SearchAndIcon>
);

TemplateSearchBar.propTypes = {
  handleClick: PropTypes.func.isRequired,
  iconContainerId: PropTypes.string.isRequired,
  iconId: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  isFocused: PropTypes.bool.isRequired,
  searchId: PropTypes.string.isRequired,
  searchRef: PropTypes.instanceOf(Object).isRequired,
  searchTerm: PropTypes.string.isRequired,
  setSearchTerm: PropTypes.func.isRequired,
};

export default TemplateSearchBar;
